export const DEFAULT_ASSISTANT_NAME = 'Default Configuration';
